export const ALL_INCLUSIVE = 'all-inclusive';
